import React from 'react';
import {
  StyleSheet,
  View,
  StyleProp,
  ViewStyle,
  Image,
  ImageSourcePropType,
  Text,
  TouchableOpacity,
} from 'react-native';
import {colors} from 'src/assets';
import {VerificationCheckIcon, ChevronRightIcon} from './components';
import {Icon} from 'src/components';

export type HeaderProps = {
  style?: StyleProp<ViewStyle>;
  imageSource?: ImageSourcePropType;
  name?: string;
  email?: string;
  isVerified?: boolean;
  onPress?: () => void;
};

export const Header: React.FC<HeaderProps> = ({
  style,
  imageSource,
  name,
  email,
  isVerified,
  onPress,
}) => {
  return (
    <TouchableOpacity style={[styles.container, style]} onPress={onPress}>
      {imageSource ? (
        <Image source={imageSource} style={styles.avatar} />
      ) : (
        <View style={[styles.avatar, styles.avatarEmpty]}>
          <Icon name={'person'} color={colors.chokuGray5} size={32} />
        </View>
      )}
      <View style={styles.content}>
        {name ? (
          <View style={styles.name}>
            <VerificationCheckIcon
              style={styles.verification}
              color={isVerified ? colors.chokuRed : '#E3E3E3'}
            />
            <View style={{flex: 1}}>
              <Text style={{flex: 1}}>{name}さん</Text>
            </View>
          </View>
        ) : null}
        {email ? <Text>{email}</Text> : null}
      </View>
      <ChevronRightIcon />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: colors.white,
    borderRadius: 4,
    paddingHorizontal: 16,
    paddingVertical: 13,
  },
  avatar: {
    width: 62,
    height: 62,
    borderRadius: 31,
  },
  avatarEmpty: {
    backgroundColor: colors.gray1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginLeft: 10,
  },
  name: {
    flexDirection: 'row',
  },
  verification: {
    marginRight: 8,
  },
});
